import { FC, ReactElement, useState } from 'react';
import Header from '@components/DesignLibrary/Header';
import PageContext from '@components/DesignLibrary/PageContext';
import { useIsMobile } from '@hooks';
import { SIZES } from '@styles/media';
import Tabs from '@/components/DesignLibrary/Tabs';
import { m } from 'framer-motion';
import LayoutRightPanel from './LayoutRightPanel';
import s from './MainPanelSubLayout.module.scss';

type Props = {
  header: Pick<
    Parameters<typeof Header>[0],
    'title' | 'description' | 'secondaryActions' | 'actions' | 'actionsComponent' | 'topRightComponent' | 'noDivider'
  >;
  pageContext: Parameters<typeof PageContext>[0];
  rightPanel?: {
    title: string;
    component: ReactElement;
    id?: string;
  };
  homeTabTitle: string;
  isFetching?: boolean;
};

const MainPanelSubLayout: FC<Props> = ({ children, header, pageContext, rightPanel, homeTabTitle, isFetching }) => {
  const isMobile = useIsMobile(SIZES.xl);
  const [tab, setTab] = useState<'first' | 'second'>('first');
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={
        isFetching
          ? {
            opacity: [0.33, 1],
            transition: {
              duration: 0.5,
              repeat: Infinity,
              repeatType: 'mirror',
            },
          }
          : {
            opacity: 1,
          }
      }
      className={s.container}
    >
      <Header {...header} />
      <PageContext {...pageContext} />
      {isMobile
        ? (
          <div className={s.pageContent} style={{ flexDirection: 'column', height: '100%' }}>
            {rightPanel && (
              <Tabs
                inputName={`${homeTabTitle}-layout-tabs`}
                inputs={[
                  {
                    id: 'first',
                    label: homeTabTitle,
                  },
                  {
                    id: 'second',
                    label: rightPanel.title,
                  },
                ]}
                onChange={id => setTab(id as 'first' | 'second')}
                className={s.tabs}
                checked={tab}
              />
            )}
            {tab === 'first' && <>{children}</>}
            {tab === 'second' && rightPanel && <>{rightPanel.component}</>}
          </div>
        )
        : (
          <div className={s.pageContent} style={{ flexDirection: 'row' }}>
            <div className={s.mainPanel}>{children}</div>
            {rightPanel && !isMobile && <LayoutRightPanel id={rightPanel.id}>{rightPanel.component}</LayoutRightPanel>}
          </div>
        )}
    </m.div>
  );
};

export default MainPanelSubLayout;
